const route = (event) => {
    event = event || window.event;
    event.preventDefault();
    window.history.pushState({}, "", event.currentTarget.href);
    handleLocation();
};

const withAppVersion = (url) => {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}v=${APP_VERSION}`;
};

const routes = {
    "/": {
        page: "./pages/login.html",
        pageKey: "login",
        script: "/js/login.js",
    },
    "#cadastro": {
        page: "./pages/cadastro.html",
        pageKey: "cadastro",
        script: "/js/form.js",
    },
    "#completar": {
        page: "./pages/completar.html",
        pageKey: "completar",
        script: "/js/completar.js",
    },
    "#login": {
        page: "./pages/login.html",
        pageKey: "login",
        script: "/js/login.js",
    },
    "#live": {
        page: "./pages/live.html",
        pageKey: "live",
        script: "/js/live.js",
    },
    "#agenda": {
        page: "./pages/agenda.html",
        pageKey: "agenda",
        script: "/js/agenda.js",
    },
    "#perguntas": {
        page: "./pages/perguntas.html",
        pageKey: "perguntas",
        script: "/js/perguntas.js",
    },
};

const notFoundRoute = {
    page: "./pages/404.html",
    pageKey: "404",
};

const isLocalDev = () => {
    const host = window.location.hostname;
    return host === "localhost" || host === "127.0.0.1";
};

const buildAppUrl = (routePath, search = "") => {
    const normalizedRoute = routePath === "/"
        ? ""
        : (routePath.startsWith("#") ? routePath : `#${routePath.replace(/^\/+/, "")}`);
    const suffix = `${search}${normalizedRoute}`;

    return suffix ? `./${suffix}` : "./";
};

const applyPageAssets = (pageKey) => {
    const pageAssets = typeof window.getPageAssets === "function"
        ? window.getPageAssets(pageKey)
        : {};

    ["iac-logo", "convexas-logo"].forEach(function (id) {
        const el = document.getElementById(id);
        if (!el) return;

        const src = pageAssets[id];
        if (src) {
            el.src = src;
            el.hidden = false;
            return;
        }

        el.hidden = true;
    });
};

const handleLocation = async () => {
    let path = window.location.hash;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const ssid = urlParams.get('ssid');

    if (path === "") path = "/";

    const routeConfig = routes[path] || notFoundRoute;

    if (path === "#live" && !ssid && !isLocalDev()) {
        window.location.href = buildAppUrl("/");
        return;
    }

    document.body.dataset.page = routeConfig.pageKey;

    const html = await fetch(withAppVersion(routeConfig.page), { cache: "no-store" })
        .then((data) => data.text());
    document.getElementById("app-main").innerHTML = html;

    applyPageAssets(routeConfig.pageKey);

    document.querySelectorAll("script[data-route-script]").forEach((script) => {
        script.remove();
    });

    if (routeConfig.script) {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.dataset.routeScript = "true";
        s.src = withAppVersion("." + routeConfig.script);
        document.body.prepend(s);
    }
};

window.onpopstate = handleLocation;
window.route = route;
window.buildAppUrl = buildAppUrl;
window.addEventListener("resize", function () {
    const pageKey = document.body.dataset.page || "home";
    applyPageAssets(pageKey);
});

handleLocation();
